import { gql, useMutation } from "@apollo/client";
import { ApiResult } from "../../../../../graphql/types/ApiResult";

export interface SaveHandoverCarrierInput {
  id?: string;
  carrierName: string;
  shortCarrierName?: string | null;
  carrierType: number;
  contactName?: string | null;
  contactPhone?: string | null;
  centerWarehouseIds: string[];
  status: number;
}

export const SAVE_HANDOVER_CARRIER = gql`
  mutation SaveHandoverCarrier($input: SaveHandoverCarrierInput!) {
    saveHandoverCarrier(input: $input) {
      success
      code
      message
    }
  }
`;

interface SaveHandoverCarrierResponse {
  saveHandoverCarrier: ApiResult;
}

interface SaveHandoverCarrierVariables {
  input: SaveHandoverCarrierInput;
}

export const useSaveHandoverCarrier = () => {
  return useMutation<SaveHandoverCarrierResponse, SaveHandoverCarrierVariables>(SAVE_HANDOVER_CARRIER);
};
